import React, { useMemo } from 'react'

import { t, Trans } from 'src/translations'

import Image from 'shared/components/common/Image'
import Link from 'shared/components/common/link'

const Footer = () => {
  const year = useMemo(() => new Date().getFullYear(), [])

  return (
    <div className='profileFooter'>
      <div className='footer-container generic-container'>
        <div className='footer-content'>
          <div className='content-cell pure-g'>
            <div className='footer-nav pure-u-12-24 pure-u-sm-6-24'>
              <div>{t('footer.toast-inc', { year })}</div>
              <Image
                src='/icons/toast-logo.svg'
                alt='Toast'
                height={45}
                className='toast-badge'
              />
            </div>

            <ul className='footer-nav nav-down pure-u-12-24 pure-u-sm-6-24'>
              <li>
                <Link href='https://pos.toasttab.com/about'>
                  {t('footer.about-toast')}
                </Link>
              </li>
              <li>
                <Link href='https://pos.toasttab.com/'>
                  {t('footer.for-restaurants')}
                </Link>
              </li>
            </ul>

            <ul className='footer-nav nav-down pure-u-12-24 pure-u-sm-6-24'>
              <li>
                <Link
                  href='https://pos.toasttab.com/terms-of-service'
                  rel='nofollow'
                >
                  {t('footer.terms-of-service')}
                </Link>
              </li>
              <li>
                <Link href='https://pos.toasttab.com/privacy' rel='nofollow'>
                  {t('footer.privacy-statement')}
                </Link>
              </li>
              <li>
                <Link
                  href='https://pos.toasttab.com/privacy#addendum'
                  rel='nofollow'
                >
                  <Trans
                    i18nKey='footer.do-not-sell-my-personal-information'
                    components={{ br: <br /> }}
                  />
                </Link>
              </li>
            </ul>

            <div className='footer-nav nav-down pure-u-12-24 pure-u-sm-6-24'>
              <Trans
                i18nKey='footer.made-with-love-in-boston'
                components={{
                  Image: (
                    <Image
                      src='/icons/heart-orange.svg'
                      alt={t('footer.alt.love')}
                      height={11}
                      className='heart-icon'
                    />
                  )
                }}
              />
              <ul className='footer-nav social-media'>
                <li>
                  <a
                    href='https://instagram.com/toasttab'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <Image
                      src='icons/instagram-gray.svg'
                      alt={t('footer.alt.instagram')}
                      className='instagram'
                      height={12}
                    />
                  </a>
                </li>
                <li>
                  <a
                    href='https://x.com/toasttab'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <Image
                      src='icons/x-white-1.svg'
                      alt={t('footer.alt.x')}
                      className='twitter'
                      height={12}
                    />
                  </a>
                </li>
                <li>
                  <a
                    href='https://www.facebook.com/toasttab/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <Image
                      src='icons/facebook-gray.svg'
                      alt={t('footer.alt.facebook')}
                      className='facebook'
                      height={12}
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
